import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const HeroContent = () => <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-12 lg:px-24 z-10">
    <div className="max-w-2xl text-left">
      <h1 className="font-bold leading-tight tracking-tighter mb-6 bg-gradient-to-r from-foreground via-primary to-foreground bg-clip-text text-transparent !text-6xl !font-sans">Shaik Azrin &amp; Co<br /></h1>
      <p className="text-lg md:text-xl text-foreground/70 mb-8 max-w-lg font-sans">Legal excellence since 2004. Specialising in Employment Law, Industrial Relations, Civil Litigation, Conveyancing and Property Related Transactions with 29 years of seasoned expertise.&nbsp;</p>
      <div className="flex items-center gap-4">
        <Link to="/ContactPage">
          <div className="relative inline-flex group">
            <div className="absolute inset-0 rounded-sm bg-primary/20 animate-ping opacity-20" style={{
            animationDuration: '3s'
          }} />
            <Button size="lg" className="relative px-8 h-14 text-lg font-semibold shadow-lg hover:shadow-primary/20 transition-all duration-300 bg-gradient-to-br from-primary to-chart-4 text-primary-foreground rounded-sm">Contact Us</Button>
          </div>
        </Link>
        <Link to="/OurPeoplePage">
          <Button variant="outline" size="lg" className="px-8 h-14 text-lg font-semibold border-primary/50 text-primary hover:bg-primary/10 transition-all duration-300 rounded-sm">
            Meet our team
          </Button>
        </Link>
      </div>
    </div>
  </div>;
export default function DailyHarvestHero() {
  return <section data-section-id="240143" id="legal-excellence-since-2004" className="relative w-full bg-background text-foreground overflow-hidden">
      {}
      <div className="hidden md:block relative w-full max-w-[1920px] mx-auto">
        <AspectRatio ratio={21 / 9}>
          <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/legal_library_charcoal_overlay.png')] bg-cover bg-center opacity-10 grayscale" />
          <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-transparent" />
          <HeroContent />
        </AspectRatio>
      </div>

      {}
      <div className="block md:hidden relative w-full">
        <AspectRatio ratio={3 / 4}>
          <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/legal_library_charcoal_overlay.png')] bg-cover bg-center opacity-10 grayscale" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/90 to-background/40" />
          <HeroContent />
        </AspectRatio>
      </div>
    </section>;
}